import React from "react";

const CustomStepper = ({ steps, currentStep }) => {
  return (
    <div className="w-full flex justify-center space-x-24 py-8">
      {steps.map((step, index) => (
        <div key={index} className="flex flex-col items-center">
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center mb-2
              ${
                currentStep === index + 1
                  ? "bg-primary-500 text-white"
                  : "bg-gray-100 text-gray-600"
              }`}
          >
            {index + 1}
          </div>
          <span
            className={`text-sm ${
              currentStep === index + 1
                ? "text-gray-900 font-medium"
                : "text-gray-500"
            }`}
          >
            {step}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CustomStepper;
